import { ORDERED_LIST_STYLES } from './list-utils';
import type { ListDefinitions, ListMarkerStyleName, ParagraphElement } from '../../slate-api';
import type { BlockType } from '../shared/types';

export type BlockTypeResult = {
  listLevel: number;
  styleName: ListMarkerStyleName | undefined;
  type: BlockType;
};

export function getBlockType(
  paragraph: ParagraphElement,
  listDefinitions: ListDefinitions
): BlockTypeResult {
  if (!paragraph.listProps) return { listLevel: 0, styleName: undefined, type: 'P' };

  const { listId, listLevel } = paragraph.listProps;
  const listDefinition = listDefinitions[listId];

  if (!listDefinition) return { listLevel, styleName: undefined, type: 'BULLET' };

  const levelDefinition = listDefinition[listLevel];
  const styleName = levelDefinition.style.name;
  const type = styleName && ORDERED_LIST_STYLES.has(styleName) ? 'NUMBERED' : 'BULLET';

  return { listLevel, styleName, type };
}
